(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["cabinet-product-description"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.cabinet-product-desc').forEach(function (wrapper) {
    if (wrapper.dataset.truncation !== 'true') return;

    const content = wrapper.querySelector('.cabinet-product-desc__content');
    const toggle = wrapper.querySelector('.cabinet-product-desc__toggle');
    if (!content || !toggle) return;

    const inner = content.firstElementChild;

    function isClamped() {
      if (!inner) return false;
      return inner.scrollHeight > inner.clientHeight + 1;
    }

    function init() {
      if (isClamped()) toggle.hidden = false;
    }

    toggle.addEventListener('click', function () {
      const expanded = this.getAttribute('aria-expanded') === 'true';
      this.setAttribute('aria-expanded', String(!expanded));
      content.classList.toggle('is-expanded', !expanded);
      wrapper.classList.toggle('is-expanded', !expanded);
      if (expanded) init();
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-description"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.product-desc-truncate[data-truncation="true"]').forEach(function (wrapper) {
    var lines = parseInt(wrapper.dataset.truncateLines, 10) || 3;
    var rte = wrapper.querySelector('.rte');
    var toggle = wrapper.querySelector('.product-desc-truncate__toggle');
    if (!rte || !toggle) return;

    rte.style.setProperty('--pdt-lines', lines);

    function isClamped() {
      return rte.scrollHeight > rte.clientHeight + 2;
    }

    function init() {
      if (isClamped()) toggle.hidden = false;
    }

    toggle.addEventListener('click', function () {
      var expanded = this.getAttribute('aria-expanded') === 'true';
      this.setAttribute('aria-expanded', String(!expanded));
      wrapper.classList.toggle('is-expanded', !expanded);
      if (expanded) init();
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  });
  } catch(e) { console.error(e); }
})();

})();
